import React from 'react';
import { Typography } from 'antd';
import { RichTextEditor, type PlainlyFormat } from '../../../modules/rich-text';
import { useResponsiveSizes } from '../../../hooks/use-responsive-sizes';
import type { BaseFieldProps } from '../../../types/form-renderer';
import type { RichTextField as RichTextFieldType, FormattedText } from '../../../types/templates';

const { Text } = Typography;

type Props = BaseFieldProps<RichTextFieldType> & { onBlur?: () => void };

export const RichTextField: React.FC<Props> = ({ field, onChange, onBlur, commonStyle, labelStyle, error }) => {
  const { fontSize } = useResponsiveSizes();

  return (
    <div style={commonStyle}>
      <Text type='secondary' style={{ ...labelStyle, textTransform: 'uppercase' }}>
        {field.label}
      </Text>

      <RichTextEditor
        placeholder={field.placeholder || 'Escribí tu texto aquí...'}
        onChange={(v: PlainlyFormat) => onChange(v as FormattedText)}
        onBlur={onBlur}
        hasError={!!error}
        maxLines={field.maxLines}
      />

      {error && (
        <Text type='danger' style={{ fontSize: fontSize.sm, marginTop: 4 }}>
          {error}
        </Text>
      )}
    </div>
  );
};
